<template>
  <DashboardBaseSidebar :is-sidebar-shown="isSidebarShown" @close="emitClose">
    <component :is="isAdmin ? DashboardAdminSidebarHub : 'div'" @navigate="emitNavigate">
      <DashboardSidebarContentSection>
        <DashboardSidebarFeatures
          :features="features"
          @navigate="(route: RouteLocationNormalizedLoaded) => $emit('navigate', route)"
        />
      </DashboardSidebarContentSection>
      <slot :selected-callback="selectedCallback" />
    </component>
  </DashboardBaseSidebar>
</template>

<script setup lang="ts">
  // Types
  import type { RouteLocationNormalizedLoaded } from 'vue-router';
  import type { PropType } from 'vue';
  import type { TFeature } from '~/modules/dashboard/types';

  // Components
  import DashboardBaseSidebar from '~/modules/dashboard/sidebar/base/DashboardBaseSidebar.vue';
  import DashboardSidebarContentSection from '~/modules/dashboard/sidebar/content-section/DashboardSidebarContentSection.vue';
  import DashboardSidebarFeatures from '~/modules/dashboard/sidebar/features/DashboardSidebarFeatures.vue';

  const DashboardAdminSidebarHub = defineAsyncComponent(
    () => import('~/modules/dashboard/admin/sidebar/hub/DashboardAdminSidebarHub.vue')
  );

  const props = defineProps({
    isSidebarShown: {
      type: Boolean,
      required: true,
    },
    features: {
      type: Array as PropType<TFeature[]>,
      default: () => [],
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'navigate', route: RouteLocationNormalizedLoaded | string): void;
  }>();

  const selectedCallback = () => props.isSidebarShown && emitClose();
  const emitClose = () => emit('close');
  const emitNavigate = (route: RouteLocationNormalizedLoaded | string) => emit('navigate', route);
</script>
